import React, { useEffect, useRef, useState } from 'react';
import styles from './Editor.module.scss';
import { QueryFactory } from 'services/api';
import { RichEditComponent } from 'components/devexpress/RichEdit/RichEditComponent';
import { DXR, RichEdit } from 'components/devexpress/RichEdit/dx-richedit';
import { updateParagraphStyles } from 'pages/authorized/documents/components/richedit-helper';
import { useTemplateExportDropdown } from 'pages/authorized/documents/components/document-exporting';
import { CustomDropDown } from 'pages/authorized/documents/components/richEdit/CustomDropDown';
import 'pages/authorized/documents/components/DocumentExportLoader/DocumentExportLoader.scss';
import { RichEditUiProvider } from 'pages/authorized/documents/components/richEdit/RichEditUiProvider';

type Props = {
  templateId: number;
};

const TemplateEditor: React.FC<Props> = React.memo(
  function TemplateEditor(props) {
    const richEdit = useRef<RichEdit>(null!);
    const [isRichEditLoaded, setIsRichEditLoaded] = useState(false);
    const [isContentSet, setIsContentSet] = useState(false);

    const templateQuery = QueryFactory.TemplateQuery.useGetQuery(
      props.templateId,
      {
        enabled: !!props.templateId,
      },
    );

    const exportDropdownInnerProps = useTemplateExportDropdown({
      id: props.templateId,
    });

    // Opens document, adjusts read-only mode
    useEffect(() => {
      if (!isContentSet) {
        if (templateQuery.data?.content && templateQuery.isFetchedAfterMount) {
          richEdit.current.openDocument(
            templateQuery.data?.content,
            templateQuery.data?.name,
            DXR.DocumentFormat.OpenXml,
            () => {
              updateParagraphStyles(richEdit.current);
            },
          );
          setIsContentSet(true);
        }
      }
    }, [
      templateQuery.data,
      templateQuery.data?.content,
      templateQuery.isFetchedAfterMount,
      isContentSet,
    ]);

    return (
      <>
        <RichEditComponent
          initialize={() => {}}
          onLoaded={() => {
            setIsRichEditLoaded(true);
            if (templateQuery.isFetching) {
              richEdit.current.loadingPanel.show();
            }
          }}
          richEditRef={richEdit}
          className={styles.container}
          readOnly={true}
        />
        <RichEditUiProvider richEdit={richEdit}>
          {isRichEditLoaded && (
            <>
              <CustomDropDown
                {...exportDropdownInnerProps}
                tab={DXR.RibbonTabType.File}
                insertIndex={5}
              />
            </>
          )}
        </RichEditUiProvider>
      </>
    );
  },
);

export default TemplateEditor;
